import {useEffect, useRef} from 'react';
import {useAppSelector} from '@/hooks';
import {MODALS_IDS} from '@Components/modal-container';
import {handOffPendingInChatJobsToGrowl, hasPendingInChatJobs} from '@Components/ai-chat-window/lib/in-chat-job-handoff.library';

/** Hands a running in-chat job off to a growl when the loading modal closes by any means; gated on `hasPendingInChatJobs()`. */
export const useInChatJobDismissWatcher = (): void => {
  const isLoadingModalOpen = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.AI_ACTION_LOADING_MODAL]?.isOpen ?? false;
  });
  const wasOpenRef = useRef(false);

  useEffect(() => {
    if (wasOpenRef.current && !isLoadingModalOpen && hasPendingInChatJobs()) {
      handOffPendingInChatJobsToGrowl();
    }
    wasOpenRef.current = isLoadingModalOpen;
  }, [isLoadingModalOpen]);
};
